(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CrmTagDialogController', CrmTagDialogController);

    CrmTagDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CrmTag'];

    function CrmTagDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CrmTag) {
        var vm = this;

        vm.crmTag = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.crmTag.id !== null) {
                CrmTag.update(vm.crmTag, onSaveSuccess, onSaveError);
            } else {
                CrmTag.save(vm.crmTag, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:crmTagUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
